import type { TypePolicies } from '../../utils/types/TypePolicies';
import { mediaStatesMap } from './MediaState.state';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getMediaState: {
        read: (_existing, { args }) => {
          return mediaStatesMap.get(args?.mediaStateId);
        },
      },
    },
  },
};
